export default __webpack_public_path__ + "poi-500-0f6ab26628911fd577ab667c0740f3ca.png";